import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import {useNavigate } from 'react-router-dom'

import TextField from "@mui/material/TextField/TextField";
import { useFormik } from 'formik';
import firebase from '../../firebase/firebase'
import * as yup from 'yup';
import Snackbar from "@mui/material/Snackbar/Snackbar";
import Alert from "@mui/material/Alert/Alert";
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import TopBar from "../../components/TopbarV3";
import Paper from "@mui/material/Paper/Paper";
import {ListItem,
  ListItemIcon, ListItemText}  from "@mui/material"
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PostNotification from "../../helpers/post-notification";
import ScrollToTop from '../../utils/scrollTop';
import PostActivity from "../../helpers/post-activity";
// import MenuItem from "@mui/material/MenuItem/MenuItem";


const tiers = [
  {
    title: "TAOST BASIC",
    img: 200,
    text:"$100/mo",
    id: 2,
    price: 100,
    learn: false,
    items: [{
      icon: 'Check',
      text: 'Limited to fully viewing 5 projects'
    }, {
      icon: 'Check',
      text: '1Gb of visual media uploaded'
    }
    ]



  },
  {
    title: "TAOST PRO",
    img: 500,
    text:"$200/mo",
    id: 3,
    price: 200,
    learn: false,
    items: [{
      icon: 'Check',
      text: 'Unlimited fully viewing of projects'
    }, {
      icon: 'Check',
      text: '5Gb of visual media uploaded'
    },
    ]
  },
];

function MembershipPlan() {
  const [selected, setSelected] = React.useState();
  const [selectedPackage, setSelectedPackage] = React.useState();
  const [options, setOptions] = React.useState(tiers);
  const [message, setMessage] = React.useState({text: '', type:'success'});
  const { user, setUser, profile, setProfile } = useContext(AuthUserContext);

  const navigator = useNavigate();
  const [open, setOpen] = React.useState(false);
  const selectedObject = (price, pack) => {
    setSelected(price)
    setSelectedPackage(pack)

  }
  const promoCheck = async (promo) => {
    try {
      setOptions(tiers)

      const promoRef = firebase.firestore().collection('promoCodes');
      const promoSnapshot = await
        promoRef
          .where("promo", "==", promo)
          .get()
          .then();

      if (promoSnapshot && promoSnapshot.docs.length > 0) {
        const discount = (promoSnapshot.docs[0].data().discount / 100) * selected;
        const id = promoSnapshot.docs[0].id
        setSelected(selected - discount);
        setOptions((options) => {
          const list = options.map((d) => {
            if (d.price === selected) {
              return {
                ...d,
                price: selected - discount,
              }
            } else return d
          })

          return list
        })
        await promoRef.doc(id)
          .collection('usedBy')
          .add({ uid: user.uid, when: new Date() });
        setMessage({text:'Discount applied successfully!', type: 'success'})
        handleClick()
      } else {
        setMessage({text:'Sorry, this code is either invalid or has expired.', type: 'error'})
        handleClick()
      }
    } catch (e) {

      setMessage({text:'Sorry, this code is either invalid or has expired.', type: 'error'})
      handleClick()

    }
  }
  const formik = useFormik({
    initialValues: {promo: ''},
    validationSchema:  yup.object({
      promo: yup
        .string('Promo code')
        .required('Promo code is required'),
    }),
    onSubmit: async (values) => {
      const userRef = firebase.firestore().collection('users')
      const memberRef = firebase.firestore().collection('memberships')
      const userdata = await userRef.where('uid', '==', user.uid).get()
      const pack = options.find((opt) => opt.price === 0);
      delete pack.items
      delete pack.learn

      await memberRef.add({
        name: userdata.docs[0].data().name,
        userType: userdata.docs[0].data().userType,
        uid: userdata.docs[0].data().uid,
        promo: values.promo,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        package: pack.title,
        price: pack.price,
        monthlyPrice: pack.text,
        status: 'pending'
      })
      await userRef.doc(userdata.docs[0].id)
        .update({membership: {package: pack.title, usePromoCode: true, createdAt: firebase.firestore.FieldValue.serverTimestamp()}})
      setProfile({
        ...userdata.docs[0].data,
        id: userdata.docs[0].id,
        membership: {
          package: pack.title,
          usePromoCode: true,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        }})
      debugger
      await PostActivity({
        text: `You have successfully applied promo code on ${pack.title}`,
        uid: profile.uid,
        createdBy:profile?.uid
      })
      if(profile.userType === 'creator') {

        navigator('/creator/membership-payment', {state: {pack : selectedPackage}})

      } else if (profile?.userType === 'investor'){

        navigator('/investor/membership-payment', {state: {pack : selectedPackage}})

      } else {
        navigator('/artists/membership-payment', {state: {pack : selectedPackage}})

      }
      window.location.reload(true)
    },
  });
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  return (
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar />*/}
      <Container  maxWidth="md" component="main" sx={{ mt: 8, mb:10 }}>
        <Typography variant="h4" align="left" color="text.primary" component="p">
          Choose the <font color="#204488">membership</font>&nbsp;best suited for your needs
          {/*{messages?.joinNow?.who_are_you?.pageTitle}*/}
        </Typography>

      </Container>


      {/* End hero unit */}
      <Container maxWidth="md" component="main" >
        <Grid container spacing={5} alignItems="self-start" justifyContent={"center"} >
          {options.map((tier, ind) => (
            // Enterprise card is full width at sm breakpoint
            <Grid
              item
              key={tier.title}
              xs={12}
              sm={tier.title === 'Enterprise' ? 12 : 6}
              md={4}
            >
              <Paper elevation={4} >
                <Box
                  sx={{
                    // display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    

                    mb: 2,
                    p:2,
                    backgroundColor: `${tier.price !== selected ? '#ffffff': '#204488' }`, borderRadius: '10px'
                  }}
                >
                  <Stack onClick={() => selectedObject(tier.price, tier)} justifyContent="space-between"
                         alignItems="center" sx={{minHeight: 250}}>

                    <Typography  variant="h6" onClick={() => selectedObject(tier.price, tier)} sx={{
                      color: tier.price !== selected ? '#204488': '#ffffff'
                    }}>
                      {tier.title}
                    </Typography>
                    <img src={`/assets/packages/${tier.img}.png`}  onClick={() => selectedObject(tier.price, tier)}  alt=""/>
                    <Typography  variant="h6" onClick={() => selectedObject(tier.price, tier)} sx={{
                      color: tier.price !== selected ? '#204488': '#ffffff'
                    }}>
                      ${tier.price}/mo
                    </Typography>





                  </Stack>
                  <p style={{ 
                    color: tier.price !== selected ? '#204488': '#ffffff', fontSize:14, fontWeight:'600', textDecoration:'underline', cursor:'pointer'}}
                  onClick={() => {
                    const list = [];
                    options.forEach(d => {
                      if (d.title === tier.title) {
                        list.push({...d, learn: !tier.learn})
                      } else list.push(d);
                    })
                    setOptions(list)
                  }}>
                    {!tier.learn  && 'See more' }
                  </p>
                  {
                    tier.learn &&
                    <Stack justifyContent="space-between"
                           alignItems="center" >
                      {  tier.items.map((d) => (
                          <ListItem>
                            <ListItemIcon sx={{minWidth: 40 ,color: tier.price !== selected ? '#204488': '#ffffff'}}>
                              {d.icon === 'Check' ? <CheckCircleIcon/>: <CancelIcon/>}
                            </ListItemIcon>
                            <ListItemText
                              sx={{fontSize:10}}
                              secondary={<Typography variant={'body2'} sx={{ color: tier.price !== selected ? '#204488': '#ffffff'}}>{d.text}</Typography>}
                            />
                          </ListItem>
                        )
                      )}

                      <p  style={{
                        color: tier.price !== selected ? '#204488': '#ffffff', fontSize:14, fontWeight:'600', textDecoration:'underline', cursor:'pointer'
                      }} onClick={() => {
                        const list = [];
                        options.forEach(d => {
                          if (d.title === tier.title) {
                            list.push({...d, learn: !tier.learn})
                          } else list.push(d);
                        })
                        setOptions(list)
                      }}>
                        {tier.learn  &&  'See less'}
                      </p>
                    </Stack>

                  }
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Container maxWidth="md" component="main" sx={{ pt: 5, }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box   component="form" onSubmit={formik.handleSubmit} sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              flexDirection:'column',
            }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Stack direction='row' justifyContent="center"
                         alignItems="center">
                    <TextField
                      value={formik.values.promo}
                      onChange={formik.handleChange}
                      error={formik.touched.promo && Boolean(formik.errors.promo)}
                      helperText={formik.touched.promo && formik.errors.promo}
                      label="Enter promo code" name="promo" variant="outlined" sx={{width:'90%', textAlign:'left'}} />
                    <Button variant={'contained'} sx={{pt: 2, pb:2, pl: 5, pr:5 , borderRadius: 0, boxShadow:'none'}} disabled={!selected} onClick={() => promoCheck(formik.values.promo)}>Apply
                    </Button>
                  </Stack>


                </Grid>
              </Grid>
              <Container disableGutters maxWidth=""  component="main" sx={{ pt: 8, pb: 6 }}>

                <Stack spacing={2} direction="row" sx={{
                  display: 'flex',
                  justifyContent: "center",
                  alignItems: 'center',

                }}>
                 
                  <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,width:"180px"}} type='submit'>Next</Button>
                  <Button variant="outlined" sx={{pt: 1, pb:1, pl: 5, pr:5,width:"180px"}} onClick={() => profile.userType === 'investor' ? navigator('/investor/additional-details') : profile?.userType === 'artist' ? navigator('/artists/additional-details') : navigator('/creator/additional-details') }>Skip</Button>

                </Stack>
              </Container>

            </Box>
          </Grid>
        </Grid>
      </Container>


      <Snackbar  open={open} autoHideDuration={60000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} onClose={handleClose}>
        <Alert onClose={handleClose} severity={message.type} sx={{ width: '100%' }}>
          {message.text}
        </Alert>
      </Snackbar>

    </React.Fragment>
  );
}

export default MembershipPlan;